import type AreaAnalysis from "../AreaAnalysis"
import type Area from "../Area"
import type AnalysisBuilder from "./AnalysisBuilder"

export default class GrowthAnalysisBuilder implements AnalysisBuilder {
	private GLOBAL_TREND_THRESHOLD_PERCENT = 6.8

	private round(value: number): number {
		return Math.round(value * 10) / 10
	}

    build(analysis: AreaAnalysis, area: Area): string {
		if (!analysis.year_on_year_median_price_change_percent) return ""
        const yearly_trend = this.round(analysis.year_on_year_median_price_change_percent)
		const area_name = area.getDisplayName()

		if (yearly_trend < 0) {
			return this.negative_trend_statement(area_name, yearly_trend)
		}
		if (yearly_trend < 1) {
			return this.slow_growth_statement(area_name, yearly_trend)
		}
		if (yearly_trend > this.GLOBAL_TREND_THRESHOLD_PERCENT) {
			return this.market_beating_trend_statement(area_name, yearly_trend)
		}
		return this.positive_trend_statement(area_name, yearly_trend)
    }

	private market_beating_trend_statement(area_name: string, value: number): string {
		return area_name  + " has shown strong growth potential with an annualised trend of " + value + "%, over the last 3 years, ahead of the broader market average of " + this.GLOBAL_TREND_THRESHOLD_PERCENT + "%."
	}

	private slow_growth_statement(area_name: string, value: number): string {
		return "Growth in " + area_name + ", over the last 3 years, has remained stagnant, showing a average annual growth of " + value + "%."
	}

	private positive_trend_statement(area_name: string, value: number): string {
		return "Growth in " + area_name + " has remained steady with an average upward growth of " + value + "% per year as measured over the last 3 years."
	}

	private negative_trend_statement(area_name: string, value: number): string {
		return area_name + "'s median price has fallen by " + Math.abs(value) + "%, indicating a potential cooling in the market, relative to the last 3 years of activity. Cooling markets are typically associated with lower demand and reduced investment confidence."
	}
}
